// Card schemes for the network breakdown + win-rate matrix columns. `icon` is the
// registry brand-logo name reused from the disputes table's ISSUER_ICON map.
export const NETWORKS = [
  { key: "visa", label: "Visa", icon: "visa" },
  { key: "mastercard", label: "Mastercard", short: "MC", icon: "mastercard" },
  { key: "amex", label: "Amex", short: "AMEX", icon: "americanexpress" },
  { key: "discover", label: "Discover", icon: "discover" }
]

const NETWORK_META = NETWORKS.reduce((meta, network) => {
  meta[network.key] = network
  return meta
}, {})

// win-rate-matrix/ in the shape WinRateGrid draws: columns from `networks` (with their logos), a
// row per category, a cell per network in the same order.
export const toWinRateGrid = (matrix) => ({
  cols: (matrix?.networks ?? []).map((key) => NETWORK_META[key] || { key, label: key }),
  rows: (matrix?.rows ?? []).map((row) => ({
    key: row.category,
    label: row.label,
    cells: row.cells.map((cell) => ({
      col: cell.network,
      winRate: cell.win_rate,
      won: cell.won_count,
      resolved: cell.resolved_count
    }))
  }))
})
